var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5","d":"M16 2l-9.625 9.625L2 7.25"}));
}

Tick.defaultProps = {"width":"18","height":"13","viewBox":"0 0 18 13"};

module.exports = Tick;

Tick.default = Tick;
